/* Draggable before/after comparison — shared by the stats and before/after sections. */
(function () {
  function init(el) {
    if (el.dataset.tbaInit) return;
    el.dataset.tbaInit = '1';

    var clip = el.querySelector('[data-tba-clip]');
    var clipR = el.querySelector('[data-tba-clip-r]');
    var line = el.querySelector('[data-tba-line]');
    var knob = el.querySelector('[data-tba-knob]');
    var raf = 0;
    var pending = null;

    function paint(p) {
      if (clip) clip.style.clipPath = 'inset(0 ' + (100 - p).toFixed(2) + '% 0 0)';
      if (clipR) clipR.style.clipPath = 'inset(0 0 0 ' + p.toFixed(2) + '%)';
      if (line) line.style.left = p.toFixed(2) + '%';
      if (knob) knob.style.left = p.toFixed(2) + '%';
    }

    function set(clientX) {
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      pending = Math.max(4, Math.min(96, ((clientX - r.left) / r.width) * 100));
      if (!raf) {
        raf = requestAnimationFrame(function () {
          raf = 0;
          paint(pending);
        });
      }
    }

    function move(e) { set(e.clientX); }
    function up() {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    }

    el.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      set(e.clientX);
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
    });

    // paint the declared starting position
    var start = parseFloat((el.style.getPropertyValue('--tba-x') || '67').replace('%', ''));
    paint(isNaN(start) ? 67 : start);
  }

  function scan() { document.querySelectorAll('[data-tba]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // re-scan when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', scan);
})();
